import { getOr } from '@/utils/options';
import ListItem, { List } from 'components/src/list';
import Image from 'next/image';
import * as React from 'react';
import { PackageCardFieldsFragment } from 'types/generated';

type Props = {
  productItems?: PackageCardFieldsFragment['productItems'] | null;
};

const ProductItems = ({ productItems }: Props) => {
  if (!productItems?.itemCollection?.items) {
    return null;
  }

  return (
    <List classes="rounded-28 bg-white-15 p-8">
      {productItems.itemCollection.items.map((item, index) => (
        <ListItem
          key={index}
          id={getOr(item?.title, index.toString())}
          text={getOr(item?.title, '')}
          icon={item?.icon?.url && <Image src={item?.icon?.url} fill alt={getOr(item?.title, '')} />}
          disabled={getOr(item?.disabled, false)}
        ></ListItem>
      ))}
    </List>
  );
};
export default ProductItems;
